namespace GeniuzPOS.SalePromoCamp {
    export namespace PsPromoApHdService {
        export const baseUrl = 'SalePromoCamp/PsPromoApHd';

        export declare function Create(request: Serenity.SaveRequest<PsPromoApHdRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsPromoApHdRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsPromoApHdRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsPromoApHdRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "SalePromoCamp/PsPromoApHd/Create",
            Update = "SalePromoCamp/PsPromoApHd/Update",
            Delete = "SalePromoCamp/PsPromoApHd/Delete",
            Retrieve = "SalePromoCamp/PsPromoApHd/Retrieve",
            List = "SalePromoCamp/PsPromoApHd/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsPromoApHdService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
